import { useEffect, useState } from "react";
import { useDataProvider, useGetList } from "react-admin";
import { CardContent, Card, Button, Grid, Typography, List, ListItem, ListItemText, Divider } from "@mui/material";

import ClientChartBulkForm from "./ClientChartBulkForm";

const ClientChartBulkEdit = ({ selectedChartIds, onCancel, onSuccess, onError }) => {
    const dataProvider = useDataProvider();
    const { data, isLoading, isError, isSuccess, error } = useGetList("portal/clientCharts");

    const [selectedCharts, setSelectedCharts] = useState([]);
    const [selectedSeries, setSelectedSeries] = useState([]);

    useEffect(() => {
        if (error) {
            console.error(error);
            onError();
        }
    }, [error]);

    useEffect(() => {
        if (!isLoading && isSuccess && !isError) {
            const records = data.filter((item) => selectedChartIds.includes(item.id));
            setSelectedCharts(records.map((record) => record.name));
        }
    }, [isLoading, isSuccess]);

    const onSave = async () => {
        const updatePromises = selectedChartIds.map(async (id) => {
            const { data } = await dataProvider.getOne("portal/clientCharts", { id });
            const { seriesIds, ...rest } = data;
            const newSeriesIds = seriesIds.concat(selectedSeries.filter((id) => !seriesIds.includes(id)));
            const newData = { seriesIds: newSeriesIds, ...rest };
            return dataProvider.update("portal/clientCharts", { id: id, data: newData });
        });

        await Promise.all(updatePromises)
            .then(onSuccess())
            .catch(() => {
                console.error(error);
                onError();
            });
    };

    return (
        <>
            <Grid container justifyContent="flex-end" mb={2}>
                <Button variant="outlined" onClick={onCancel}>
                    Back
                </Button>
            </Grid>
            <Grid container justifyContent="flex-start" spacing={3}>
                <Grid item xs={3}>
                    <Card>
                        <CardContent>
                            <Typography variant="h6">Selected Client Charts</Typography>
                        </CardContent>
                        <Divider />

                        <List dense={true}>
                            {selectedCharts.map((chart) => (
                                <ListItem key={chart}>
                                    <ListItemText primary={chart} />
                                </ListItem>
                            ))}
                        </List>
                    </Card>
                </Grid>

                <Grid item xs={7} mr={1}>
                    <ClientChartBulkForm
                        onSave={onSave}
                        onCancel={onCancel}
                        onError={onError}
                        setSelectedSeries={setSelectedSeries}
                    />
                </Grid>
            </Grid>
        </>
    );
};

export default ClientChartBulkEdit;
